import React, { useState } from 'react';
import { submitLead } from '../lib/submitLead';

const COUNTRY_CODES = [
  { code: '+1',   label: 'US +1'  },
  { code: '+91',  label: 'IN +91' },
  { code: '+44',  label: 'UK +44' },
  { code: '+971', label: 'AE +971'},
  { code: '+65',  label: 'SG +65' },
  { code: '+61',  label: 'AU +61' },
];

export default function EnquiryForm({ product = 'inspectly' }) {
  const [loading, setLoading]         = useState(false);
  const [countryCode, setCountryCode] = useState('+1');
  const [status, setStatus]           = useState({ type: null, text: '' });
  const [formData, setFormData]       = useState({
    full_name: '',
    email:     '',
    phone:     '',
    message:   '',
  });

  const update = (field) => (e) =>
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: null, text: '' });

    try {
      await submitLead({
        full_name: formData.full_name.trim(),
        email:     formData.email.trim(),
        phone:     `${countryCode} ${formData.phone.trim()}`,
        message:   formData.message.trim() || undefined,
        product,
      });

      setFormData({ full_name: '', email: '', phone: '', message: '' });
      setStatus({ type: 'success', text: "Thanks! We'll be in touch shortly." });
    } catch (err) {
      console.error('Enquiry submission failed:', err);
      setStatus({
        type: 'error',
        text: 'Something went wrong. Please try again in a moment.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="lp-enquiry-form" onSubmit={handleSubmit}>
      <div className="lp-enquiry-row">
        <label className="lp-enquiry-field">
          <span className="lp-enquiry-label">Full Name</span>
          <input
            type="text"
            className="lp-enquiry-input"
            placeholder="Jane Doe"
            value={formData.full_name}
            onChange={update('full_name')}
            required
          />
        </label>

        <label className="lp-enquiry-field">
          <span className="lp-enquiry-label">Email</span>
          <input
            type="email"
            className="lp-enquiry-input"
            placeholder="jane@company.com"
            value={formData.email}
            onChange={update('email')}
            required
          />
        </label>
      </div>

      <label className="lp-enquiry-field">
        <span className="lp-enquiry-label">Phone</span>
        <div className="lp-enquiry-phone">
          <select
            className="lp-enquiry-select"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            aria-label="Country code"
          >
            {COUNTRY_CODES.map((c) => (
              <option key={c.code} value={c.code}>{c.label}</option>
            ))}
          </select>
          <input
            type="tel"
            className="lp-enquiry-input"
            placeholder="4155551234"
            value={formData.phone}
            onChange={update('phone')}
            required
          />
        </div>
      </label>

      <label className="lp-enquiry-field">
        <span className="lp-enquiry-label">Message <span className="lp-enquiry-optional">(optional)</span></span>
        <textarea
          className="lp-enquiry-textarea"
          rows={4}
          placeholder="Tell us about your inspection workflow or questions..."
          value={formData.message}
          onChange={update('message')}
        />
      </label>

      <button type="submit" className="lp-enquiry-submit" disabled={loading}>
        {loading ? 'Submitting...' : 'Book Meeting'}
      </button>

      {status.type && (
        <div className={`lp-enquiry-status lp-enquiry-status-${status.type}`}>
          {status.text}
        </div>
      )}
    </form>
  );
}
